import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  previewContainer: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
